import React, { useState } from 'react'
import { Table, DataType, ColumnListType, CustomButton, Tooltip } from '@ui-kit'
import { noop } from 'lodash'
import WelcomeCall from './WelcomeCall'
import PatientInformationSidePanel from './SidePanel'

const PersonalizedInterventions = ({
  welcomeCallVisible,
  setWelcomeCallVisible,
  setSelectedTabIndex,
}: {
  welcomeCallVisible: boolean
  setWelcomeCallVisible: React.Dispatch<React.SetStateAction<boolean>>
  setSelectedTabIndex: React.Dispatch<React.SetStateAction<number>>
}) => {
  let index = 0
  const patientData = [
    { label: 'Name', value: 'Bill Martin' },
    { label: 'Date of Birth', value: '03/10/1962' },
    {
      label: 'Address',
      value: '1234 Main St, Apt 7700, Sedona, Arkansas - 86336',
    },
  ]
  const drugData = [
    { label: 'Drug Name', value: 'Tecfidera' },
    { label: 'Drug NDC', value: '64406-0007-03' },
    {
      label: 'Drug Indication',
      value: 'Relapsing forms of Multiple Sclerosis',
    },
    { label: 'Dosage Form', value: 'Injectable' },
    { label: 'ICD10', value: 'G35: Multiple Sclerosis' },
  ]
  const [data] = useState<DataType[]>([
    {
      intervention: 'Welcome Call',
      start_date: '18/09/2024',
      end_date: '--/--/----',
    },
    {
      intervention: 'Benefits Investigation',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Quick - Start Pack',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'PA and Appeals Process Support',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'RX Status Communication',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Bridge Program Delivery',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Nutritionist',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Financial Assistance',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Field Nurse Reach out',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Satisfaction/Tolerability After Initial Dose',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Therapy Transition Needs',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Disease Education',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'HCP Office Support',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
    {
      intervention: 'Office Education',
      start_date: '--/--/----',
      end_date: '--/--/----',
    },
  ])

  const [columns, setColumns] = useState<ColumnListType[]>([
    {
      label: 'Intervention',
      key: 'intervention',
      type: 'component',
    },
    {
      label: 'Start Date',
      key: 'start_date',
      type: '',
    },
    {
      label: 'End Date',
      key: 'end_date',
      type: '',
    },
  ])

  const onRowClick = (
    e: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    record: DataType,
    index: number
  ) => {
    e.stopPropagation()
    if (index === 0 && record !== null) {
      setWelcomeCallVisible(true)
    }
  }

  return (
    <div className="w-full p-4 flex gap-2 font-primary">
      <div className="w-[70%]">
        {welcomeCallVisible ? (
          <WelcomeCall
            setVisibleState={setWelcomeCallVisible}
            setSelectedTabIndex={setSelectedTabIndex}
          />
        ) : (
          <Table
            columnList={columns}
            data={data}
            additionalColumns={[]}
            handleChange={noop}
            handleRowClick={onRowClick}
            headerClick={noop}
            columnSetter={setColumns}
            optionsList={[]}
            edit={true}
          >
            {(dataItem) => {
              index++
              return (
                <div className="flex gap-2">
                  <span className=" font-light text-xs">{index}. </span>
                  <span className="font-light text-xs">
                    <Tooltip content={dataItem.intervention?.toString() ?? ''}>
                      {dataItem.intervention}
                    </Tooltip>
                  </span>
                  <span className=" font-light text-xs">&gt;</span>
                </div>
              )
            }}
          </Table>
        )}
      </div>
      <div className="right w-[30%]">
        <PatientInformationSidePanel
          header="Patient Information"
          data={patientData}
        />
        <PatientInformationSidePanel
          header="Drug Information"
          data={drugData}
        />
        <CustomButton
          color="primary"
          isFilled={true}
          size="small"
          widthClass="w-fit mt-2"
          onClick={() => setSelectedTabIndex(0)}
        >
          <span>View Full Profile</span>
        </CustomButton>
      </div>
    </div>
  )
}

export default PersonalizedInterventions
